/**
 * Controlled set of Amplitude event names.
 * Add new entries here explicitly — do not construct event names dynamically.
 */
export const AnalyticsEventNames = Object.freeze({
    PAGE_VIEW: 'page view',
    PROMO_BANNER_EXPOSURE: 'promo banner exposure',
    PROMO_CODE_APPLY: 'promo code apply',
});

/**
 * Controlled set of page name property values for page view events.
 * Values are the prefix of the former event name (e.g. "signup quiz page view" → "signup quiz"),
 * or the lowercased former AnalyticsLayout page title (e.g. "Login" → "login").
 * Add new entries here explicitly — do not use document.title or other free-form strings.
 */
export const AnalyticsPageNames = Object.freeze({
    LEAD_CAPTURE: 'lead capture',
    SIGNUP_QUIZ: 'signup quiz',
    QUIZ_SUMMARY: 'quiz summary',
    REGISTRATION: 'registration',
    LOGIN: 'login',
    FORGOT_PASSWORD: 'forgot password',
    STOREFRONT_CONFIGURATION_PREVIEW: 'storefront configuration preview',
    FEATURED: 'featured',
    SHOP_MISFITS_PERKS: 'shop misfits perks',
    SHOP_MISFITS_PERKS_REDEEMED: 'shop misfits perks redeemed',
    BRAND: 'brand',
    BUY_IT_AGAIN: 'buy it again',
    MEMBER_DEALS: 'member deals',
    SALE: 'sale',
    RESCUED: 'rescued',
    DEPRECATED_SHOP_MISFITS_PERKS: '[deprecated] shop misfits perks',
    SHOP_ALL_AISLE: 'shop all aisle',
    AISLE: 'aisle',
    SEARCH: 'search',
    PRODUCT: 'product',
    UNGATED_PRODUCT: 'ungated product',
    MY_ACCOUNT: 'my account',
    MY_PROFILE: 'my profile',
    ORDERS: 'orders',
    ORDER_CONFIRMATION: 'order confirmation',
    ORDER_FEEDBACK: 'order feedback',
    ORDER_TRACKING: 'order tracking',
    ORDER_DETAILS: 'order details',
    UPCOMING_DELIVERIES: 'upcoming deliveries',
    FOOD_PREFERENCES: 'food preferences',
    PROMOTIONS: 'promotions',
    MY_PLAN: 'my plan',
    REFERRALS: 'referrals',
    MISFITS_PERKS: 'misfits perks',
    NOTIFICATIONS: 'notifications',
    PLUS_MEMBERSHIP: 'plus membership',
    BEST_DEALS: 'best deals',
});

/**
 * Routes that opt out of AnalyticsLayout page view tracking.
 * Add a PathPattern here when a page implements its own page view tracking
 * (e.g. needs page-level data or a deferred/gated fire).
 * @see https://reactrouter.com/api/utils/matchPath
 */
export const trackPageOptOutRoutes = Object.freeze([
    { path: '/shop/product/:id' },
    { path: '/shop' },
    { path: '/join', end: true },
    // Index + step URLs (/account, /delivery, /payment) — each implements its own tracking via `RegistrationFlow`.
    { path: '/join/registration', end: false },
]);
